<template>
  <a
    class="navi-link"
    :class="{
      'is-active': isLinkActive,
    }"
    :href="href"
  >
    <slot>{{ label }}</slot>
  </a>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  href: {
    type: String,
    required: true,
  },
  isActiveValidator: {
    type: Function,
    default: ({ currentPath, listPath }) => (currentPath === listPath),
  },
})

const isLinkActive = computed(() => props.isActiveValidator({
  currentPath: window.location.pathname,
  listPath: props.href,
}))
</script>

<style scoped lang="scss">
.navi-link {
  outline: none;
  padding: 21px 7.5px 15px;
  height: 18px;
  color: #636363;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  border-bottom: 3px solid transparent;
  white-space: nowrap;
  line-height: normal;

  @media screen and (min-width: 64em) {
    padding-left: 12px;
    padding-right: 12px;
  }

  &.is-active, &:hover {
    color: #0386f4;
    background-color: transparent;
    position: relative;
    z-index: 1;
    border-left: none;
    border-bottom-color: #0386f4;
    text-decoration: none;
  }
}
</style>
